var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H1V1H7V3H3V7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.56 6.02L17.6667 6C17.8533 6 18 6.14667 18 6.33333V16.4133C18 16.5667 17.9 16.6867 17.76 16.7333L14 18L10 16.6L6.44 17.98L6.33333 18C6.14667 18 6 17.8533 6 17.6667V7.58667C6 7.43333 6.1 7.31333 6.24 7.26667L10 6L14 7.4L17.56 6.02ZM16 15.2145L14.0124 15.884L14 15.8797V9.51762L14.0353 9.52998L16 8.76839V15.2145ZM13 9.16762L11 8.46762V14.8297L13 15.5297V9.16762ZM10 8.11762V14.4797L9.96469 14.4673L8 15.2289V8.78286L9.98759 8.11328L10 8.11762Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17H1V23H7V21H3V17Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21V23H23V17H21V21H17Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3V1H23V7H21V3H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyFocus);
export default __webpack_public_path__ + "static/media/property_focus.bc6f647a7de06fa9efe0e433d838e9fb.svg";
export { ForwardRef as ReactComponent };